/* global jQuery COMPONENTS */

COMPONENTS.ComponentNavigation = (function ($) {
  function ComponentNavigation () {
    this.$component = $('[data-ecs-component="component-navigation"]')
    this.$accordionElems = this.$component.find('[data-ecs-accordion]')
    const viewportLaptop = window.matchMedia('(min-width: 1024px)')

    this.setMenuOpenHeight = function (menuOnly) {
      const menuDrawer = this.$component.find('[data-drawer-wrap]')
      let $drawerHeight = this.$component.outerHeight() + 'px'

      if (menuOnly === true) {
        if (window.CSS && CSS.supports('max-height', '100svh')) {
          menuDrawer.css('max-height', '100svh');
        } else if (window.CSS && CSS.supports('max-height', '100dvh')) {
          menuDrawer.css('max-height', '100dvh');
        } else menuDrawer.css('max-height', '100vh');
      } else {
        if (window.CSS && CSS.supports('max-height', '100svh')) {
          menuDrawer.css('max-height', 'calc(100svh - ' + $drawerHeight + ')')
        } else if (window.CSS && CSS.supports('max-height', '100dvh')) {
          menuDrawer.css('max-height', 'calc(100dvh - ' + $drawerHeight + ')')
        } else menuDrawer.css('max-height', 'calc(100vh - ' + $drawerHeight + ')')
          // topDrawer.css('max-height', 'calc(100% - ' + $bottomDrawerHeight + ')')
      }
    }

    this.toggleMenu = function ($menu, $request) {
      const menu = $menu.attr('data-control-drawer')
      const $menuButtons = $('[data-control-drawer="' + menu + '"]')
      let scrollTop = $('html').scrollTop()

      this.setMenuOpenHeight()

      if ($request === 'close') {
        scrollTop = parseInt($('html').css('top'))

        $menuButtons.each(function () {
          $(this).attr('aria-expanded', false)
        })

        this.$component.find('[data-drawer-wrap][data-drawer="' + menu + '"]').removeClass('ecs_open')
        $('html').removeClass('ecs_menu_open')
        $('html,body').scrollTop(-scrollTop)
      } else {
        $menuButtons.each(function () {
          $(this).attr('aria-expanded', function (i, attr) {
            return attr === 'true' ? 'false' : 'true'
          })
        })

        this.$component.find('[data-drawer-wrap][data-drawer="' + menu + '"]').toggleClass('ecs_open')
        if (!$menu.hasClass('ecs_nearby_button')) { // don't apply open class for Nearby Communities button
          $('html').toggleClass('ecs_menu_open')

          if ($('html').hasClass('ecs_menu_open')) {
            $('html').css('top', -scrollTop) // runs when the menu opens
          } else {
            scrollTop = parseInt($('html').css('top'))
            $('html').scrollTop(-scrollTop) // runs when the menu closes
          }
        }
      }
    }

    this.menuResets = function () {
      const component = this

      console.log('menu resets')

      if ($('html').hasClass('ecs_menu_open')) { // close the main menu if open on rotate event
        $('[data-control-drawer="corporate-menu"]').click()
      }
      $(component).find('.ecs_open').removeClass('ecs_open')
      $(component).find('[aria-expanded]').attr('aria-expanded', false)
      component.setMenuOpenHeight()
    }

    ComponentNavigation.prototype.init = function () {
      const component = this
      const viewportLaptop = window.matchMedia('(min-width: 1112px)')

      // Set the menu drawer height on load (to facilitate transition animation)
      setTimeout(function () {
        component.setMenuOpenHeight()
      }, 500)

      // If the notification bar is closed, recalc menu height
      $('[data-ecs-components-control="banner-toggle"]').click(function () {
        $('.ecs_components__notification__wrap').slideUp()

        setTimeout(function () {
          component.setMenuOpenHeight()
        }, 500)
      })

      // Drawer buttons/controls on click
      component.$component.find('[data-control-drawer]').click(function () {
        const viewportLaptop = window.matchMedia('(min-width: 1112px)')
        if (!viewportLaptop.matches) {
          component.toggleMenu($(this))
        }
      })

      // If screen rotates, reset the menu states
      $(window).on('orientationchange', function () {
        component.menuResets()
      })

      // If screen resizes, reset the menu states
      $(window).on('resize', function () {
        // if (!viewportLaptop.matches && COMPONENTS.isTouchDevice()) {
          component.menuResets()
        // }
        // component.setMenuOpenHeight()
      })

      $('[data-ecs-components-control="cookiebanner-toggle"]').click(component.setMenuOpenHeight())
    }
  }

  return ComponentNavigation
})(jQuery)

document.addEventListener('components_init', function (e) {
  // Hook into the main components init
  COMPONENTS.componentNavigation = new COMPONENTS.ComponentNavigation()
  COMPONENTS.componentNavigation.init()
})
